import { ChangeEvent, FC, MutableRefObject, useMemo } from "react";
import { Box, Pagination, Stack, Table, Theme, useMediaQuery } from "@mui/material";
import { AdvertTableBody } from "../advertTableBody";
import { getStyles } from "./styles";

interface IProps {
    scrollRef: MutableRefObject<HTMLDivElement | null>;
    advertList: any[];
    page: number;
    pageAmount: number;
    handleStatus: (id: number, status: string) => void;
    handleDelete: (id: number) => void;
    handlePageChange: (event: ChangeEvent<unknown>, page: number) => void;
    handleUploadReport: (id: number, name: string) => void;
};

export const AdvertTable: FC<IProps> = ({ advertList, handlePageChange, pageAmount, page, handleStatus, handleDelete, handleUploadReport, scrollRef }) => {
    const lgDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const styles = useMemo(() => getStyles(lgDown), [lgDown]);

    return (
        <>
            <Box>
                <Box sx={styles.tableWrapper} ref={scrollRef}>
                    <Table>
                        <AdvertTableBody
                            adverts={advertList}
                            handleStatus={handleStatus}
                            handleDelete={handleDelete}
                            handleUploadReport={handleUploadReport}
                        />
                    </Table>
                </Box>
                <Stack direction='row' justifyContent='center' sx={styles.paginationWrapper}>
                    <Pagination
                        page={page}
                        count={pageAmount || 1}
                        color="primary"
                        onChange={handlePageChange}
                    />
                </Stack>
            </Box>
        </>
    )
};